import {HomeLayout} from '../components/layouts';

export const PublicRouteRenderer = () => {
    return <HomeLayout />;
};

export default PublicRouteRenderer;
